import { isNaN } from 'lodash';

import { DOCUMENT_NAME_TO_ID, SHARED_DOCUMENTS } from 'global/SharedDocumentFields';
import {
  EIV_STATUS,
  EIV_STATUS_ALLOW_EXPERT_RENDERING,
  MISSING_PROVIDER_OBJECT,
  NO_RESULTS_SENTINEL,
  TENANT_ID,
} from 'global/constants';

import { isDevelopment, isLocal, isProduction } from 'utils/StageUtils';
import { getTenantId } from 'utils/tenantUtil';

export const checkKeyDown = (e) => {
  // hack for multiline text fields to accept newlines
  if (
    e.target.name !== 'changes' &&
    e.target.name !== 'questionInput' &&
    (e.code === 'Enter' || e.key === 'Enter')
  )
    e.preventDefault();
};
export const allowOnlyNumber = (e) => {
  if (e === '') {
    return e;
  }
  if (!/^\d+$/.test(e)) {
    return e.slice(0, -1);
  }

  return e;
};
const DUMMY_FILE_INPUT_DATA = {
  name: 'char_lengths.PNG',
  contentType: 'image/png',
  base64: 'data:image/png;base64,content',
  size: 45091,
};

export const fillFormUploadIVNE = (initialValues) => {
  if (!initialValues || typeof initialValues !== 'object') {
    return initialValues;
  }
  (initialValues.documentsTrigger || []).forEach((documentId) => {
    const ivDocumentKey = SHARED_DOCUMENTS[documentId].name;
    initialValues[ivDocumentKey] = [DUMMY_FILE_INPUT_DATA];
  });

  Object.keys(initialValues.expertTrigger || {}).forEach((ivExpertKey) => {
    const expertTriggers = initialValues[ivExpertKey];
    Object.keys(expertTriggers).forEach((expertTriggerDocumentId) => {
      initialValues[ivExpertKey][expertTriggerDocumentId] = [DUMMY_FILE_INPUT_DATA];
    });
  });

  return initialValues;
};

export const fillFormUploadIVNEFI = fillFormUploadIVNE;

export const getExpertValidityDateGas = (row, installerGasValidityDate) => {
  if (row.statusGas === EIV_STATUS.NEW && row.isMainGas) return 'Datum nach Prüfung';
  if (row.expertGasValidityDate) return row.expertGasValidityDate;
  return '-';
};
export const getExpertValidityDateEnergy = (row) => {
  if (row.statusEnergy === EIV_STATUS.NEW && row.isMainEnergy) return 'Datum nach Prüfung';
  if (row.expertEnergyValidityDate) return row.expertEnergyValidityDate;
  return '-';
};
export const getExpertStatusEnergy = (row) => {
  if (!EIV_STATUS_ALLOW_EXPERT_RENDERING.includes(row.statusEnergy)) return '-';
  return row.isMainEnergy ? 'Stamm' : 'Gast';
};

export const getExpertStatusGas = (row) => {
  if (!EIV_STATUS_ALLOW_EXPERT_RENDERING.includes(row.statusGas)) return '-';
  return row.isMainGas ? 'Stamm' : 'Gast';
};
export const fillFormUploadIVDEB = (initialValues) => {
  const expertsIds = Object.keys(initialValues).filter((key) => !isNaN(parseInt(key, 10)));

  Object.keys(DOCUMENT_NAME_TO_ID).forEach((documentKey) => {
    expertsIds.forEach((expertId) => {
      if (initialValues[expertId][documentKey]) {
        initialValues[expertId][documentKey] = [DUMMY_FILE_INPUT_DATA];
      }
    });
    if (initialValues[documentKey]) {
      initialValues[documentKey] = [DUMMY_FILE_INPUT_DATA];
    }
  });
  return initialValues;
};
export const getComboBoxOptionsForCraftChamber = (craftChambers) => {
  if (!craftChambers) {
    return [MISSING_PROVIDER_OBJECT, NO_RESULTS_SENTINEL];
  }
  const craftChamberOptions = craftChambers.map((craftChamber) => ({
    title: craftChamber.name,
    value: craftChamber.id,
  }));
  return [...craftChamberOptions, MISSING_PROVIDER_OBJECT, NO_RESULTS_SENTINEL];
};
export const getComboBoxOptionsForGridnetProviders = (gridnetProviders) => {
  if (!gridnetProviders) {
    return [MISSING_PROVIDER_OBJECT, NO_RESULTS_SENTINEL];
  }

  const gridnetProviderOptions = gridnetProviders
    // not changing the name of item with id 1 nor removing it here as the clerks
    //  wants the eiv label
    .filter((gridnetProvider) => !gridnetProvider.geloescht)
    .map((gridnetProvider) => ({
      title: gridnetProvider.name,
      value: gridnetProvider.id,
    }));
  return [...gridnetProviderOptions, MISSING_PROVIDER_OBJECT, NO_RESULTS_SENTINEL];
};

export const getComboBoxOptionsForBetriebsarten = (betriebsarten) => {
  if (!betriebsarten) {
    return [MISSING_PROVIDER_OBJECT, NO_RESULTS_SENTINEL];
  }

  const betriebsartOptions = betriebsarten
    .filter((betriebsart) => !betriebsart.geloescht)
    .map((betriebsart) => ({
      title: betriebsart.name,
      value: String(betriebsart.id),
    }));

  return [...betriebsartOptions, MISSING_PROVIDER_OBJECT, NO_RESULTS_SENTINEL];
};
export const TESTING_ACCOUNTS_ITEM_MAP = [
  {
    label: `${isDevelopment() || isLocal() ? '1. ' : ''}Stamm Strom Haupt`,
    value: 'MainEnergyNonH',
  },
  {
    label: `${isDevelopment() || isLocal() ? '2. ' : ''}Stamm Strom Hilfs`,
    value: 'MainEnergyH',
  },
  { label: `${isDevelopment() || isLocal() ? '3. ' : ''}Stamm Gas Haupt`, value: 'MainGasNonH' },
  { label: `${isDevelopment() || isLocal() ? '4. ' : ''}Stamm Gas Hilfs`, value: 'MainGasH' },
  {
    label: `${isDevelopment() || isLocal() ? '5. ' : ''}Stamm Strom Haupt - Stamm Gas Haupt`,
    value: 'MainEnergyNonHMainGasNonH',
  },
  {
    label: `${isDevelopment() || isLocal() ? '6. ' : ''}Stamm Strom Hilfs - Stamm Gas Haupt`,
    value: 'MainEnergyHMainGasNonH',
  },
  {
    label: `${isDevelopment() || isLocal() ? '7. ' : ''}Stamm Strom Haupt - Stamm Gas Hilfs`,
    value: 'MainEnergyNonHMainGasH',
  },
  {
    label: `${isDevelopment() || isLocal() ? '8. ' : ''}Stamm Strom Hilfs - Stamm Gas Hilfs`,
    value: 'MainEnergyHMainGasH',
  },
  {
    label: `${isDevelopment() || isLocal() ? '9. ' : ''}Stamm Strom Haupt - Gast Gas Haupt`,
    value: 'MainEnergyNonHGuestGasNonH',
  },
  {
    label: `${isDevelopment() || isLocal() ? '10. ' : ''}Stamm Strom Hilfs - Gast Gas Haupt`,
    value: 'MainEnergyHGuestGasNonH',
  },
  {
    label: `${isDevelopment() || isLocal() ? '11. ' : ''}Stamm Strom Haupt - Gast Gas Hilfs`,
    value: 'MainEnergyNonHGuestGasH',
  },
  {
    label: `${isDevelopment() || isLocal() ? '12. ' : ''}Stamm Strom Hilfs - Gast Gas Hilfs`,
    value: 'MainEnergyHGuestGasH',
  },
  {
    label: `${isDevelopment() || isLocal() ? '13. ' : ''}Gast Strom Haupt - Stamm Gas Haupt`,
    value: 'GuestEnergyNonHMainGasNonH',
  },
  {
    label: `${isDevelopment() || isLocal() ? '14. ' : ''}Gast Strom Haupt - Stamm Gas Hilfs`,
    value: 'GuestEnergyNonHMainGasH',
  },
  {
    label: `${isDevelopment() || isLocal() ? '15. ' : ''}Gast Strom Hilfs - Stamm Gas Haupt`,
    value: 'GuestEnergyHMainGasNonH',
  },
  {
    label: `${isDevelopment() || isLocal() ? '16. ' : ''}Gast Strom Hilfs - Stamm Gas Hilfs`,
    value: 'GuestEnergyHMainGasH',
  },
  {
    label: `${isDevelopment() || isLocal() ? '17. ' : ''}Gast Strom Haupt`,
    value: 'GuestEnergyNonH',
  },
  { label: `${isDevelopment() || isLocal() ? '18. ' : ''}Gast Gas Haupt`, value: 'GuestGasNonH' },
  {
    label: `${isDevelopment() || isLocal() ? '19. ' : ''}Gast Strom Hilfs`,
    value: 'GuestEnergyH',
  },
  { label: `${isDevelopment() || isLocal() ? '20. ' : ''}Gast Gas Hilfs`, value: 'GuestGasH' },
  {
    label: `${isDevelopment() || isLocal() ? '21. ' : ''}Gast Strom Haupt - Gast Gas Haupt`,
    value: 'GuestEnergyNonHGuestGasNonH',
  },
  {
    label: `${isDevelopment() || isLocal() ? '22. ' : ''}Gast Strom Hilfs - Gast Gas Haupt`,
    value: 'GuestEnergyHGuestGasNonH',
  },
  {
    label: `${isDevelopment() || isLocal() ? '23. ' : ''}Gast Strom Haupt - Gast Gas Hilfs`,
    value: 'GuestEnergyNonHGuestGasH',
  },
  {
    label: `${isDevelopment() || isLocal() ? '24. ' : ''}Gast Strom Hilfs - Gast Gas Hilfs`,
    value: 'GuestEnergyHGuestGasH',
  },
];
export const getTestingAccountItemMap = (tenantId) => {
  const lvnStromOnly = ['MainEnergyNonH', 'MainEnergyH', 'GuestEnergyNonH', 'GuestEnergyH'];
  if (tenantId === TENANT_ID.LVN) {
    return TESTING_ACCOUNTS_ITEM_MAP.filter((account) => lvnStromOnly.includes(account.value));
  }
  return TESTING_ACCOUNTS_ITEM_MAP;
};
export const areExpertContactsEnabled = !isProduction() || getTenantId() === TENANT_ID.MTN;
